import React, {useState, useEffect} from "react";
import {useHistory} from "react-router-dom";
import {useSession} from "../../../util/Session";
import { Divider } from 'antd';
export default function AccountVerify(){

    const history = useHistory(); 
    const [session, setSession] = useSession(); 

    let hasToken = false;

    if (history.location.search) {
        if (history.location.search.includes("?token=")) {
            hasToken = history.location.search.replace("?token=", "");
        }
    }

    const [token] = useState(hasToken);
    
    const checkToken = () =>{
        if(token){
           
            let user = { "email_address" : token}
            setSession({...session, "user" : user});
            history.push({"pathname" : "/account/create", "state" : {"token" : token}})
        }
    }

    useEffect(checkToken, [])
   
    const displayMessage = () =>{
        return(
            <>
                <h2>Please verify your email address</h2>
                <div aria-hidden><Divider /></div>
                <p>You have entered {history.location.state.email_address.address} as your account email</p>
                <p>To complete the creation of your account, we have sent you an email that contains your account activation link.</p>
            </>
        )
    }

    const displayRedirect = () =>{
        return(
            <>
                <h2>Please verify your email address</h2>
                <div aria-hidden><Divider /></div>
                <p>Redirecting...</p>
            </>
        )
    }

    const display = () =>{
        if(token){
            return displayRedirect(); 
        } else {
            return displayMessage(); 
        }
    }
   
    return display(); 

}